/* Provencelia : barre « Ajouter au panier » fixe sur mobile (fiche produit).
   29/09/2026 : première version (apparaissait une fois le bouton principal dépassé).
   12/10/2026 : visible dès l'ouverture de la fiche, prix + prix barré + état du stock,
   bulle de chat remontée au-dessus de la barre.
   12/10/2026 (2) : iPhone — la barre d'adresse flottante de Safari (iOS 26) passait sur la barre :
   marge basse supplémentaire sur iOS 26+ (assets/pv-fiche-mobile.css, .pv-barre--ios) et
   décalage calculé avec visualViewport quand le navigateur réduit la zone visible.
   Le bouton déclenche le vrai bouton de la fiche (même formulaire, même quantité, même pop-up
   panier). Données : snippets/pv-stock ([data-pv-barre]). Styles : assets/pv-complements.css
   et assets/pv-fiche-mobile.css (.pv-barre). Sous 700 px uniquement. */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 699px)');

  function remonterChat(hauteur) {
    var essais = 0;
    var attente = setInterval(function () {
      essais += 1;
      var hote = document.getElementById('pvc-chat-root');
      var racine = hote && hote.shadowRoot;
      if (racine) {
        clearInterval(attente);
        if (racine.querySelector('style[data-pv-barre]')) return;
        var style = document.createElement('style');
        style.setAttribute('data-pv-barre', '');
        style.textContent = '@media (max-width:699px){.pvc{bottom:' + (hauteur + 12) + 'px!important}}';
        racine.appendChild(style);
      } else if (essais > 40) {
        clearInterval(attente);
      }
    }, 250);
  }

  function lancer() {
    var source = document.querySelector('[data-pv-barre]');
    var bouton = document.querySelector('.quantity_selector__custom--buy-buttons button[type="submit"]');
    if (!source || !bouton || bouton.disabled || document.querySelector('.pv-barre')) return;

    var barre = document.createElement('div');
    barre.className = 'pv-barre pv-barre--fixe is-visible';
    barre.innerHTML =
      (source.dataset.image ? '<img class="pv-barre__image" alt="" src="' + source.dataset.image + '">' : '') +
      '<div class="pv-barre__infos"><span class="pv-barre__nom"></span><span class="pv-barre__prix"></span><span class="pv-barre__note"></span></div>' +
      '<button type="button" class="pv-barre__bouton"></button>';

    barre.querySelector('.pv-barre__nom').textContent = source.dataset.titre || '';

    var prix = barre.querySelector('.pv-barre__prix');
    prix.textContent = source.dataset.prix || '';
    if (source.dataset.prixBarre) {
      var barreEl = document.createElement('span');
      barreEl.className = 'pv-barre__barre';
      barreEl.textContent = source.dataset.prixBarre;
      prix.appendChild(barreEl);
    }

    var note = barre.querySelector('.pv-barre__note');
    if (source.dataset.stock) {
      note.textContent = source.dataset.stock;
      if (source.dataset.statut === 'bas') note.classList.add('pv-barre__note--bas');
    } else {
      note.remove();
    }

    barre.querySelector('.pv-barre__bouton').textContent = (bouton.textContent || '').trim();
    document.body.appendChild(barre);
    document.body.classList.add('pv-barre-active');

    // iPhone / iPad. Depuis iOS 26, la barre d'adresse de Safari est une pastille flottante posée
    // PAR-DESSUS le bas de la page (avant, c'était une barre opaque sous la page : rien à faire).
    // Safari 26 annonce « Version/26 » mais fige « OS 18_6 » : on lit Version/ d'abord.
    var ios = /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var versionIos = (navigator.userAgent.match(/Version\/(\d+)/) || navigator.userAgent.match(/OS (\d+)_/) || [])[1];
    if (ios && parseInt(versionIos, 10) >= 26) {
      barre.classList.add('pv-barre--ios');
      document.body.classList.add('pv-barre-ios');
    }

    // Si le navigateur réduit la zone réellement visible (barre d'outils par-dessus la page),
    // on remonte la barre d'autant. Ignoré pendant un zoom au doigt.
    var vv = window.visualViewport;
    if (vv) {
      var recaler = function () {
        if (vv.scale > 1.01) return;
        var recouvrement = Math.round(window.innerHeight - (vv.height + vv.offsetTop));
        barre.style.bottom = (recouvrement > 0 && recouvrement < 120 ? recouvrement : 0) + 'px';
      };
      vv.addEventListener('resize', recaler);
      vv.addEventListener('scroll', recaler);
      recaler();
    }

    barre.querySelector('.pv-barre__bouton').addEventListener('click', function () {
      bouton.click();
    });

    if (MOBILE.matches) remonterChat(barre.offsetHeight || 72);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
